import Analytics, { InteractionInputEvent, MilestoneInputEvent } from '@ecs-uk/web-common-analytics';

export const trackFreeAccountCtaClick = () => {
  Analytics.publish(
    InteractionInputEvent.fromObject({
      component: 'prod_move_chooser_free_account_cta',
      action: 'click',
      status: 'success',
    })
  );
};

export const trackRestartCtaClick = family => {
  if (family != null) {
    Analytics.publish(
      InteractionInputEvent.fromObject({
        component: `prod_move_chooser_restart_${family}_cta`,
        action: 'click',
        status: 'success',
      })
    );
  }
};

export const onRestartPageLoadECD = ({ reactivateSubscriptionFamily }) => {
  const productMovementIntentEvent = MilestoneInputEvent.fromObject({
    product_movement_intent: {
      subscription_from: 'unknown',
      subscription_to: reactivateSubscriptionFamily || 'unknown',
      is_eligible_for_trial: false,
      family: 'unknown',
      productSubscriptionLookingToMoveTo: reactivateSubscriptionFamily || 'unknown',
      isWithinFreeTrial: false,
      isPendingCancellation: false,
      daysLeftOfTrialInCurrentProductSubscription: 0,
    },
  });

  Analytics.publishOnce(productMovementIntentEvent);
};
